import React from 'react';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import { AppShell } from './app/AppShell';

function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}

export default App;
